import {Button, Typography} from 'nf-ui'
import React from 'react'
import {ModalLayout} from '~/components/ModalLayout'
import {StyledTextArea} from '~/components/Primitives/InputFields/VisibleInput'
import {ManageFiltersState} from './useManageFilters'

interface ManageFiltersProps {
    state: ManageFiltersState
    setModal: (modal: string) => void
    setFilterRulesText: (text: string) => void
    saveFilterRules: () => Promise<void>
}

export const ManageFilters: React.FC<ManageFiltersProps> = ({state, setModal, setFilterRulesText, saveFilterRules}) => {
    if (state.modal !== 'manageFilters') return null

    return (
        <ModalLayout>
            <ModalLayout.Navigation closeable={true} narrow={true} onClose={() => setModal('')} />
            <ModalLayout.Body>
                <Typography.Heading>Manage Filters</Typography.Heading>
                <Typography.Paragraph>
                    Enter one filter expression per line. Expressions are evaluated against materialised profile field
                    values.
                </Typography.Paragraph>
                <StyledTextArea
                    value={state.filterRulesText}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setFilterRulesText(e.target.value)}
                    rows={12}
                    style={{width: '100%', fontFamily: 'monospace'}}
                />
                <div style={{marginTop: 16, display: 'flex', gap: 8, justifyContent: 'flex-end'}}>
                    <Button variant="secondary" onClick={() => setModal('')}>
                        Cancel
                    </Button>
                    <Button variant="primary" loading={state.saving} onClick={() => saveFilterRules()}>
                        Save
                    </Button>
                </div>
            </ModalLayout.Body>
        </ModalLayout>
    )
}
